import ListIcons from "./listIconsFunc";

export const menuList = [
  { icon: <ListIcons type="rename" />, text: "Rename" },
  { icon: <ListIcons type="move" />, text: "Move to" },
  { icon: <ListIcons type="copy" />, text: "Copy to" },
  // { icon: <ListIcons type="favourite" />, text: "Favourites" },
  { icon: <ListIcons type="download" />, text: "Download" },
  { icon: <ListIcons type="share" />, text: "Share" },
  { icon: <ListIcons type="information" />, text: "File Information" },
  { icon: <ListIcons type="trash" />, text: "Trash" },
  { icon: <ListIcons type="Spaces" />, text: "Add to Space" }

];

export const ExternalSpaceList = [
  { icon: <ListIcons type="download" />, text: "Download" },
  { icon: <ListIcons type="information" />, text: "File Information" },


];

export const trashList = [
  { icon: <ListIcons type="restore" />, text: "Restore" },
  { icon: <ListIcons type="deleteForEver" />, text: "Delete forever" }
];

export const sharedMenuList = [
  { icon: <ListIcons type="copy" />, text: "Copy to" },
  { icon: <ListIcons type="download" />, text: "Download" },
  { icon: <ListIcons type="information" />, text: "File Information" }

  // { icon: <ListIcons type="trash" />, text: "Trash" } // Removed: Users cannot trash items shared with them
];

export const favList = [
  { icon: <ListIcons type="rename" />, text: "Rename" },
  { icon: <ListIcons type="move" />, text: "Move to" },
  { icon: <ListIcons type="copy" />, text: "Copy to" },
  { icon: <ListIcons type="favourite" />, text: "Remove from Favourites" },
  { icon: <ListIcons type="download" />, text: "Download" },
  { icon: <ListIcons type="share" />, text: "Share" },
  { icon: <ListIcons type="information" />, text: "File Information" },
  { icon: <ListIcons type="trash" />, text: "Trash" }
];
